






















import BaseTimePicker from './baseTimePicker.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

interface Time {
  HH: string;
  mm: string;
}

@Component({
  components: {
    BaseTimePicker
  }
})
export default class TimePicker extends Vue {
  @Prop({ required: false, type: Date, default: () => null })
  private value: Date | null;

  @Prop({ required: false, type: String, default: () => 'medium' })
  private size: 'medium' | 'small' | 'mini';

  private minDate = new Date(0);

  get modelValue() {
    return this.value
      ? {
        HH: ('00' + this.value.getHours()).slice(-2),
        mm: ('00' + this.value.getMinutes()).slice(-2),
      }
      : {
        HH: '',
        mm: '',
      };
  }

  set modelValue(value1: Time) {
    const date1 = value1.HH && value1.mm
      ? new Date(
        this.minDate.getFullYear(),
        this.minDate.getMonth(),
        this.minDate.getDate(),
        parseInt(value1.HH, 10),
        parseInt(value1.mm, 10),
      )
      : null;
    this.$emit('input', date1);

    if (this.value) {
      if (!!value1.HH === !!value1.mm) {
        this.$emit('change', this.value);
      }
    } else {
      if (value1.HH && value1.mm) {
        this.$emit('change', this.value);
      }
    }
  }

  private onOpen() {
    if (!this.value) {
      const el = this.$el.querySelector('.vue__time-picker-dropdown ul, .vue__time-picker .dropdown ul');
      if (el) {
        this.$nextTick(() => {
          el.scrollTop = el.scrollHeight * 3 / 8;
        });
      }
    }
  }
}
